var _excluded = ["fieldSize"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { Sizes } from "../../../constants.js";
var StyledRequiredAbbr = styled.abbr.withConfig({
  componentId: "CL__sc-pmha71-0"
})(["color:var(--highlight-color);display:inline-block;text-decoration:none;padding-left:", ";"], _ref => {
  var {
    $fieldSize
  } = _ref;
  if ($fieldSize === Sizes.LARGE) return 'var(--spacing-1)';
  if ($fieldSize === Sizes.SMALL) return 'calc(var(--spacing-1) / 2)';
  return 'calc(var(--spacing-1) / 2)';
});
var FieldRequiredAbbr = _ref2 => {
  var {
      fieldSize
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledRequiredAbbr, _extends({
    $fieldSize: fieldSize,
    "aria-label": "This field is required",
    title: "This field is required"
  }, rest), "*");
};
export default FieldRequiredAbbr;